import React, { useState } from "react";
import { Button, Dialog, Flex, Text } from "@fluentui/react-northstar";
import { Trash2 } from "react-feather";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const DeleteSkillBridgeModel = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const handleDelete = async () => {
    if (!props.itemToDelete || !props.itemToDelete.userID) {
      toast.error("No item selected for deletion");
      return;
    }

    setIsLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_EP_URL}/api/skillbridge/sb-users/${props.itemToDelete.userID}${props.user.slug}`,
        {
          headers: {
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      );

      toast.success(`${props.itemToDelete.role} deleted successfully`);
      props.getAllSkillBridgeData();
      props.onClose();
      props.setItemToDelete(null);
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Failed to delete item. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    props.setItemToDelete(null);
    props.onClose();
  };

  const d = props.itemToDelete || {};
  const fullName = `${d.firstName || ""} ${d.lastName || ""}`.trim();

  return (
    <Dialog
      open={props.isOpen}
      onCancel={handleClose}
      cancelButton="Cancel"
      confirmButton={{
        content: isLoading ? "Deleting..." : "Delete",
        loading: isLoading,
        disabled: isLoading,
      }}
      onConfirm={handleDelete}
      header={`Delete ${d.role || "User"}`}
      headerAction={{
        icon: <Trash2 />,
        title: `Delete ${d.role || "User"}`,
      }}
      content={
        <Flex
          column
          gap="gap.medium"
          className="delete-skillbridge-model-content"
        >
          <Text
            content={`Are you sure you want to delete "${
              fullName || d.email || "this user"
            }"?`}
            weight="semibold"
          />
          <Text content="This action cannot be undone." color="red" />

          {props.itemToDelete && (
            <Flex
              column
              gap="gap.small"
              style={{
                padding: "12px",
                backgroundColor: "#f3f2f1",
                borderRadius: "4px",
                marginTop: "8px",
              }}
            >
              <Text content={`Name: ${fullName || "-"}`} size="small" />
              <Text content={`Email: ${d.email || "-"}`} size="small" />
              <Text content={`Role: ${d.role || "-"}`} size="small" />
              <Text
                content={`Status: ${d.is_active ? "Active" : "Inactive"}`}
                size="small"
              />
            </Flex>
          )}
        </Flex>
      }
    />
  );
};

export default DeleteSkillBridgeModel;
